import { useState } from "react";
import { t } from "@/i18n-js/instance";
import { Listbox } from "@circle-react/components/SettingsApp/AnalyticsV2/Listbox";

interface DateGroupingOption {
  label: string;
  value: string;
}

const dateGroupingOptions: DateGroupingOption[] = [
  { label: t("analytics_v2.date_grouping.daily"), value: "daily" },
  { label: t("analytics_v2.date_grouping.weekly"), value: "weekly" },
  { label: t("analytics_v2.date_grouping.monthly"), value: "monthly" },
];

interface LocalDateGroupingDropdownProps {
  onDateGroupingChange?: (grouping: string) => void;
}

export const LocalDateGroupingDropdown = ({
  onDateGroupingChange,
}: LocalDateGroupingDropdownProps) => {
  const [dateGrouping, setDateGrouping] = useState<DateGroupingOption>(
    dateGroupingOptions[1],
  );

  const handleDateGroupingChange = (newDateGrouping: DateGroupingOption) => {
    setDateGrouping(newDateGrouping);
    onDateGroupingChange?.(newDateGrouping.value);
  };

  return (
    <Listbox
      value={dateGrouping}
      options={dateGroupingOptions}
      onChange={handleDateGroupingChange}
      className="min-w-[8rem] rounded-md"
    />
  );
};
